import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Link from 'next-translate-routes/link';

import { paths } from '@paths';

import * as S from './styles';
import { IBreadcrumbListProps } from './types';

export const BreadcrumbList: React.FC<IBreadcrumbListProps> = ({
  breadcrumbs,
  showHomeLink = true,
}) => (
  <S.Breadcrumbs>
    {showHomeLink && (
      <S.Item active={false}>
        <Link href={paths.home}>
          <a>
            <FormattedMessage defaultMessage="Home" id="ejEGdx" />
          </a>
        </Link>
      </S.Item>
    )}
    {breadcrumbs.map((breadcrumb, index) => (
      <S.Item
        key={`${breadcrumb.value}-${index}`}
        active={index === breadcrumbs.length - 1}
      >
        <Link href={breadcrumb.link}>
          <a>{breadcrumb.value}</a>
        </Link>
      </S.Item>
    ))}
  </S.Breadcrumbs>
);
